import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import styles from './styles.module.scss';
import { useAppData } from '../../../Context/appData';


function DYCTermsModal({ isTermsOpen, onToggleTerms }) {
    const [retailersList, setRetailersList] = useState([])
    const [showMerchantList, setShowMerchantList] = useState(false)
    const { getRetailersList } = useAppData()

    useEffect(() => {
        async function getRetailers() {
            try {
                const retailers = await getRetailersList()
                setRetailersList(retailers || [])
            } catch (error) {
                console.error("Error fetching retailers:", error)
                setRetailersList([])
            }
        }
        if (!retailersList || retailersList.length === 0) {
            getRetailers()
        }
        setShowMerchantList(false);
    }, [isTermsOpen])

    return (
        <Modal
            isOpen={isTermsOpen}
            toggle={onToggleTerms}
            className={styles.termsModal}>
            {showMerchantList ? (
                <>
                    <ModalHeader toggle={onToggleTerms}>
                        Charity Benefit - By Merchant
                    </ModalHeader>
                    <ModalBody>
                        <div className={styles.merchantContent}>
                            <p>
                                How much the charity receives:
                                <br />
                                We use the services of the leading gift card exchange to turn
                                your card balance into a cash donation. The percentage of the
                                value, that cards will bring for each merchant is listed
                                below.
                            </p>
                            <div className={styles.merchantTable}>
                                {retailersList && retailersList?.length > 0 ? (
                                    retailersList
                                        .sort((a, b) =>
                                            (a.Name || "").localeCompare(b.Name || "")
                                        )
                                        .map(retailer => (
                                            <div key={retailer.Id} className={styles.merchantRow}>
                                                <span className={styles.merchantName}>
                                                    {retailer.DisplayName}
                                                </span>
                                                <span className={styles.merchantValue}>
                                                    {retailer.ResellPercent}%
                                                </span>
                                            </div>
                                        ))
                                ) : (
                                    <div className={styles.merchantRow}>
                                        <span>Loading merchants...</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </ModalBody>
                </>
            ) : (
                <>
                    <ModalHeader toggle={onToggleTerms}>Terms and Conditions</ModalHeader>
                    <ModalBody>
                        <div className={styles.termsContent}>
                            <p>
                                Donations of retail gift cards are 100% tax deductible
                                donations and are non-revocable. Cards are transferred, at a
                                favorable bulk rate to our reseller, CardCash, to convert into
                                cash for distribution to our charity partners.
                            </p>
                            <p>
                                Funds are distributed quarterly, with Charity Gift
                                Certificates/Special Kids Fund, our nonprofit 501(c)3,
                                deducting a 10% administrative fund-raising and marketing fee
                                from the resale value.
                            </p>
                            <p>
                                Only charities on our charity list may be designated to
                                receive funds from your donation.
                            </p>
                            <p>
                                Please consult your tax advisor, as to your claiming a tax
                                deduction for your donation.
                            </p>
                            <button
                                onClick={() => setShowMerchantList(true)}
                                className={styles.learnMoreButton}>
                                Learn more about converting each merchant's gift card into
                                cash ...
                            </button>
                        </div>
                    </ModalBody>
                </>
            )}
        </Modal>
    );
}

export default DYCTermsModal;